import { FC, useMemo, useState } from "react";

import { NetworkIndicator } from "@/features/NetworkIndicator";
import { QueueTaskStatus } from "@/hooks/core";
import { useAppSelector } from "@/hooks/redux";
import { BaseModal, UniversalTabs } from "@/shared/ui";
import { ModalPayloads, ModalType } from "@/types";

import { PhotoUpload } from "./components/PhotoUpload";
import { SyncRequests } from "./components/SyncRequests";

interface UploadRetryModalProps {
    payload: ModalPayloads[ModalType.UploadRetry];
    onCloseModal: () => void;
}

export const UploadRetryModal: FC<UploadRetryModalProps> = ({
    onCloseModal,
    payload,
}) => {
    const { candidatesCount: photoCandidates, progress: photoProgress } =
        useAppSelector((state) => state.offline.photoUploadRetry);

    const { requestQueue, requestQueueStatus } = useAppSelector(
        (state) => state.offline,
    );

    const { photoCount, requestCount } = useMemo(() => {
        const photoRemaining = Math.max(
            0,
            photoProgress.totalCount - photoProgress.completedCount,
        );
        const photoBadge = photoProgress.isRunning
            ? photoRemaining
            : photoCandidates;

        const requestRemaining = requestQueue.filter(
            (item) => item.status === QueueTaskStatus.Pending,
        ).length;
        const requestBadge = requestQueueStatus.isRunning
            ? requestRemaining
            : requestQueue.length;

        return { photoCount: photoBadge, requestCount: requestBadge };
    }, [
        photoProgress,
        photoCandidates,
        requestQueueStatus.isRunning,
        requestQueue,
    ]);

    const { initialTab = "photo" } = payload;

    const [currentTab, setCurrentTab] = useState<string>(initialTab);

    return (
        <BaseModal
            open={true}
            onClose={onCloseModal}
            actions={null}
            mask={{ closable: true }}
            title={"Синхронізація"}
            icon={<NetworkIndicator />}
        >
            <UniversalTabs
                value={currentTab}
                onChange={setCurrentTab}
                tabs={[
                    {
                        value: "photo",
                        label: "Фото",
                        count: photoCount,
                    },
                    {
                        value: "request",
                        label: "Запити",
                        count: requestCount,
                    },
                ]}
            />

            {currentTab === "photo" && <PhotoUpload />}

            {currentTab === "request" && <SyncRequests />}
        </BaseModal>
    );
};
